import React from 'react';
import styled from 'styled-components';
import CircularCheckIcon from '../../assets/icons/circular-check.svg';
import CircularCrossIcon from '../../assets/icons/circular-cross.svg';
import CustomButton from '../CustomButton/CustomButton';
import { useTranslation } from 'react-i18next';

const EmailVerificationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 400px;

  .circular__check {
    margin-bottom: 22px;
  }

  .title {
    font-weight: 500;
    font-size: 32px;
    line-height: 38px;
    margin-bottom: 14px;

    text-align: center;
    letter-spacing: -1px;
  }

  p {
    text-align: center;
    word-break: break-word;

    @media only screen and (max-width: 768px) {
      width: 90%;
      .email {
        display: none;
      }
    }

    @media only screen and (min-width: 768px) {
      width: 80%;
    }

    @media only screen and (min-width: 1024px) {
      width: 70%;
    }
  }

  button {
    margin-top: 38px;
    margin-bottom: 54px;
  }
`;

const EmailVerificationDialogBody = ({ handleCloseIcon, message, isError }) => {
  const { t } = useTranslation();
  return (
    <EmailVerificationContainer>
      <img
        className="circular__check"
        src={isError ? CircularCrossIcon : CircularCheckIcon}
        alt="close"
        onClick={handleCloseIcon}
      />
      <h1 className="title">
        {isError ? t('Something went wrong!') : t('All Done!')}
      </h1>
      <p>{message}</p>
      <CustomButton onClick={window.close}>{t('Close Window')}</CustomButton>
    </EmailVerificationContainer>
  );
};

export default EmailVerificationDialogBody;
